@if (!isLoaded) {
  <i-loader [size]="25" [text]="'loading' | translate"></i-loader>
}
<div [ngClass]="{ noVisibility: !isLoaded }">
  <div class="row" [formGroup]="form">
    <div class="col-md-12 mb-3">
      <h5>
        {{ 'iScan.globalInfos.generalData' | translate
        }}<i class="ms-2 bi bi-question-circle" [pTooltip]="'iScan.globalInfos.concernWholeLot' | translate"></i>
      </h5>
    </div>
    <div class="col-md-3 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.entryDate' | translate }}*</span>
      </label>
      <div class="d-flex flex-row align-items-center w-100">
        <p-calendar
          class="w-100"
          [firstDayOfWeek]="1"
          appendTo="body"
          formControlName="dateEntree"
          [showIcon]="true"
          [iconDisplay]="'input'"
          dateFormat="dd/mm/yy"
          [maxDate]="maxDate"
          (onSelect)="changeMaxdateDocumentsClick($event)"
          (onInput)="changeMaxdateDocuments($event)">
        </p-calendar>
      </div>
    </div>
    <div class="col-md-3 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.documentDate' | translate }}</span>
        <i-input
          [type]="'calendar'"
          [iInput]="{ options: { maxDate: maxDateModified, dateFormat: 'dd/mm/yy' } }"
          [control]="form.get('dateDocument')">
        </i-input>
      </label>
    </div>
    <div class="col-md-3 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.dueDate' | translate }}</span>
        <i-input [type]="'calendar'" [iInput]="{ placeholder: '' }" [control]="form.get('dateEcheance')"> </i-input>
      </label>
    </div>
    <div class="col-md-3 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.postalDate' | translate }}</span>
        <i-input [type]="'calendar'" [iInput]="{ options: { maxDate: maxDateModified, dateFormat: 'dd/mm/yy' } }" [control]="form.get('datePostale')">
        </i-input>
      </label>
    </div>
    <div class="col-md-12">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'modals.remarks' | translate }}</span>
        <textarea
          rows="3"
          cols="30"
          [placeholder]="'modals.insertYourRemark' | translate"
          formControlName="remarques"
          class="super-compos-input-text form-control w-100"
          pInputTextarea></textarea>
      </label>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between align-items-center">
      <span class="d-flex justify-content-between align-items-center">
        <h5 class="iscan__batch__title me-3">{{ 'iScan.globalInfos.dataModificationByScan' | translate }}</h5>
        <span class="iscan__batch__selectAll" (click)="selectUnselectAllCards()"
          ><i class="bi bi-arrows-vertical"></i>{{ selectUnselectCardsTooltip() }}</span
        >
      </span>
      @if (isAnyScanSelected()) {
        <i-button
          size="small"
          [pTooltip]="'iScan.action.modifyMassTooltip' | translate"
          styleClass="blue me-2"
          (click)="modifyListOfCards(listOfIndexCardsSelected)"
          [text]="'iScan.action.modifyMass' | translate"></i-button>
      }
    </div>
    @for (cardInfo of displayedValues; track cardInfo; let i = $index) {
      <div class="col-md-4 mb-4">
        <p-card styleClass="card__background--light">
          <ng-template pTemplate="header">
            <div class="card__header d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <p-checkbox
                  binary="true"
                  class="me-2"
                  [(ngModel)]="listOfIndexCardsSelected[i]"
                  (onChange)="modifyListOfCheckedCards(i)"></p-checkbox>
                <span class="cursor--pointer" (click)="modifyListOfCheckedCards(i)"
                  >{{ 'iScan.globalInfos.scan' | translate }} {{ cardInfo.courrierIndex }}</span
                >
              </div>
              <span class="buttonRounded" [pTooltip]="'iScan.action.updateScan' | translate: { value: cardInfo.courrierIndex }"
                ><i class="icon bi bi-pencil size20" (click)="modifySingleCard(cardInfo)"></i
              ></span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <p class="m-0">
              <b>{{ 'global.service' | translate }}*</b> :
              @if (cardInfo.serviceLabel) {
                <span>{{ cardInfo.serviceLabel }}</span>
              }
              @if (!cardInfo.serviceLabel) {
                <span class="text-danger">{{ 'iScan.information.serviceIsMissing' | translate }}</span>
              }
            </p>
            @if (cardInfo.scanningCenterLabel) {
              <p class="m-0">
                <b>{{ 'global.scanningCenter' | translate }}</b> : {{ cardInfo.scanningCenterLabel }}
              </p>
            }
            @if (cardInfo.natureLabel) {
              <p class="m-0">
                <b>{{ 'global.nature' | translate }}</b> : {{ cardInfo.natureLabel }}
              </p>
            }
            @if (cardInfo.sourceLabel) {
              <p class="m-0">
                <b>{{ 'global.source' | translate }}</b> : {{ cardInfo.sourceLabel }}
              </p>
            }
            @if (cardInfo.recipientLabel) {
              <p class="m-0">
                <b>{{ 'global.recipient' | translate }}</b> : {{ cardInfo.recipientLabel }}
              </p>
            }
            @if (cardInfo.classificationCodeLabel) {
              <p class="m-0">
                <b>{{ 'global.classificationCode' | translate }}</b> : {{ cardInfo.classificationCodeLabel }}
              </p>
            }
            @if (cardInfo.recommendedRef) {
              <p class="m-0">
                <b>{{ 'global.recommendedRef' | translate }}</b> : {{ cardInfo.recommendedRef }}
              </p>
            }
          </ng-template>
        </p-card>
      </div>
    }
  </div>
  <div class="d-flex justify-content-end">
    <i-button styleClass="red me-2" (click)="emitCloseModal()" [text]="'cancel' | translate"></i-button>
    <i-button styleClass="green" [disabled]="!form.valid" (click)="submitDatas()" [text]="'save' | translate"></i-button>
  </div>
</div>

@if (openModificationCardModal) {
  <i-modal
    [visible]="openModificationCardModal"
    [header]="modalHeaderModificationCard"
    [modalParameters]="modalParamsModificationCard"
    (emitterOnVisibleChange)="openModificationCardModal = false">
    <h5 class="mb-2">
      @if (selectedCard) {
        <span> {{ 'iScan.globalInfos.scan' | translate }} {{ selectedCard.courrierIndex }} </span>
      }
      @if (selectedCards?.length) {
        <span> {{ 'iScan.globalInfos.scans' | translate }} {{ getSelectedCardsIndexes() }} </span>
      }
    </h5>
    <div class="row">
      @if (!showAllServices) {
        <div class="col-12 alert alert-info">{{ 'iScan.information.otherDataAvailable' | translate }}</div>
      }
    </div>
    <div class="row">
      <div class="col-md-6 mb-3 p-fluid">
        <label for="p-treeSelect-mass-encode-imodal" class="w-100"
          ><span class="super-compos-label-input">{{ 'global.service' | translate }}*</span>
          <p-treeSelect
            [emptyMessage]="'noResultFound' | translate"
            #treeSelect
            id="p-treeSelect-mass-encode-imodal"
            class="treeSelect"
            [options]="showAllServices ? services : servicesOnlyParent"
            selectionMode="single"
            (onShow)="onShowTreeSelect()"
            [placeholder]="'pleaseSelectAService' | translate"
            appendTo="body"
            (onNodeSelect)="select($event)"
            [filter]="true"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterBy]="'label'"
            [filterMode]="'strict'"
            [metaKeySelection]="false"></p-treeSelect>
        </label>
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span [ngClass]="{ disabledLabel: !scanningCenters.length }" class="super-compos-label-input">{{
            'global.scanningCenter' | translate
          }}</span>
          <p-dropdown
            [disabled]="!scanningCenters.length"
            styleClass="w-100"
            [virtualScroll]="true"
            (onChange)="changeScanningCenter($event)"
            [(ngModel)]="chosenScanningCenter"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="scanningCenters | sort: 'description' : 'ASC'"
            optionLabel="description"
            optionValue="codeQr"
            [filter]="true"
            [placeholder]="checkIfSomeScanningCenterExist()"
            [showClear]="true">
          </p-dropdown
        ></label>
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span [ngClass]="{ disabledLabel: !natures.length }" class="super-compos-label-input">{{ 'global.nature' | translate }}</span>
          <p-dropdown
            [disabled]="!natures.length"
            styleClass="w-100"
            [virtualScroll]="true"
            (onChange)="changeNature($event)"
            [(ngModel)]="chosenNature"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="natures | sort: 'label' : 'ASC'"
            [filter]="true"
            [placeholder]="checkIfSomeNatureExist()"
            [showClear]="true">
          </p-dropdown
        ></label>
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span [ngClass]="{ disabledLabel: !sources.length }" class="super-compos-label-input">{{ 'global.source' | translate }}</span>
          <p-dropdown
            [disabled]="!sources.length"
            styleClass="w-100"
            [virtualScroll]="true"
            [(ngModel)]="chosenSource"
            (onChange)="changeSource($event)"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="sources | sort: 'label' : 'ASC'"
            [filter]="true"
            [placeholder]="checkIfSomeSourceExist()"
            [showClear]="true"></p-dropdown
        ></label>
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span [ngClass]="{ disabledLabel: !recipients.length }" class="super-compos-label-input">{{ 'global.recipient' | translate }}</span>
          <p-dropdown
            [disabled]="!recipients.length"
            styleClass="w-100"
            [virtualScroll]="true"
            optionLabel="name"
            optionValue="contactId"
            (onChange)="changeRecipient($event)"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="recipients | sort: 'name' : 'ASC'"
            [filter]="true"
            [placeholder]="checkIfSomeRecipientExist()"
            [showClear]="true"
            [(ngModel)]="chosenRecipient"></p-dropdown
        ></label>
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span [ngClass]="{ disabledLabel: !classificationCodes.length }" class="super-compos-label-input">{{
            'global.classificationCode' | translate
          }}</span>
          <p-dropdown
            [disabled]="!classificationCodes.length"
            styleClass="w-100"
            [virtualScroll]="true"
            (onChange)="changeClassificationCode($event)"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="classificationCodes | sort: 'label' : 'ASC'"
            [filter]="true"
            [placeholder]="checkIfSomeClassificationCodeExist()"
            [showClear]="true"
            [(ngModel)]="chosenClassificationCode"></p-dropdown
        ></label>
      </div>
      <div class="col-md-12 mb-2">
        @if (showRecommendedRef) {
          <input
            type="text"
            class="form-control"
            (blur)="onChangeRecommendedRef($event)"
            [(ngModel)]="chosenRecommendedRef"
            [placeholder]="'modals.refRecommande' | translate" />
        }
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <i-button styleClass="red me-2" (click)="openModificationCardModal = false" [text]="'cancel' | translate"></i-button>
      <i-button styleClass="green" (click)="isAnyScanSelected() ? modifyMultipleDatas() : modifyDatas()" [text]="'confirm' | translate"></i-button>
    </div>
  </i-modal>
}
